import { createContext } from "react";
export const FieldsetContext = createContext(null);
//# sourceMappingURL=context.js.map